import { SxProps, Theme } from "@mui/material/styles";
import theme from "src/themes";
import GoBadge from "./GoBadge";

const DiscontinuedBadge = ({ sx }: { sx?: SxProps<Theme> }) => {
    const { discontinued } = theme.palette.badge;
    return (
        <GoBadge
            label="DISCONTINUED"
            textColor={discontinued.text}
            backgroundColor={discontinued.background}
            borderColor={discontinued.border}
            sx={sx}
        />
    );
};

export default DiscontinuedBadge;
